"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomConnection = ({ sourceX, sourceY, targetX, targetY, color }) => {
    return (react_1.default.createElement("svg", { style: { position: 'absolute', pointerEvents: 'none', zIndex: -1 } },
        react_1.default.createElement("path", { d: `M${sourceX},${sourceY} L${targetX},${targetY}`, stroke: color, strokeWidth: "2" })));
};
exports.default = CustomConnection;
